import { Builder } from '@builder.io/react';

import DataInputs from './index';

Builder.registerComponent(DataInputs, {
  name: 'DataInputs',
  inputs: [
    {
      name: 'dataLanguages',
      type: 'boolean'
    },
    {
      name: 'annotationType',
      type: 'object',
      subFields: [
        {
          name: 'scaleText',
          type: 'boolean'
        },
        {
          showIf: "options.get('scaleText')",
          name: 'scaleTextList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: [
                'Classification',
                'Named Entity Recognition',
                'Transcription',
                'Ranking',
                'Rating',
                'Generation',
                'RLHF',
                'Comparison',
                'Prompt-Response Pairs'
              ],
              defaultValue: 'Classification'
            }
          ]
        },
        {
          name: 'scaleAudio',
          type: 'boolean'
        },
        {
          showIf: "options.get('scaleAudio')",
          name: 'scaleAudioList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: ['Classification', 'Transcription'],
              defaultValue: 'Classification'
            }
          ]
        },
        {
          name: 'scale3dSensorFusion',
          type: 'boolean'
        },
        {
          showIf: "options.get('scale3dSensorFusion')",
          name: 'scale3dSensorFusionList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: ['Cuboid', 'Segmentation'],
              defaultValue: 'Cuboid'
            }
          ]
        },
        {
          name: 'scaleVideo',
          type: 'boolean'
        },
        {
          showIf: "options.get('scaleVideo')",
          name: 'scaleVideoList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: [
                'Bounding Box',
                'Classification',
                'Cuboid',
                'Ellipse (Multi-Geometry)',
                'Lines & Splines',
                'Point',
                'Polygon',
                'Segmentation'
              ],
              defaultValue: 'Bounding Box'
            }
          ]
        },
        {
          name: 'scaleMapping',
          type: 'boolean'
        },
        {
          showIf: "options.get('scaleMapping')",
          name: 'scaleMappingList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: ['2D/3D Vectors', 'Semantic'],
              defaultValue: '2D/3D Vectors'
            }
          ]
        },
        {
          name: 'scaleImage',
          type: 'boolean'
        },
        {
          showIf: "options.get('scaleImage')",
          name: 'scaleImageList',
          type: 'list',
          subFields: [
            {
              name: 'name',
              type: 'string',
              enum: [
                'Bounding Box',
                'Classification',
                'Cuboid',
                'Ellipse (Multi-Geometry)',
                'Lines & Splines',
                'Point',
                'Polygon',
                'Segmentation'
              ],
              defaultValue: 'Bounding Box'
            }
          ]
        }
      ]
    }
  ]
});
